import { TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import React from "react";
import { TestResult, User } from "../../graphql/baseTypes";
import { FilterProps } from "./types";

interface Props extends FilterProps<User> {
  value?: string | null;
}

const items: Array<TestResult> = ["invalid", "positiv", "negativ"];

const labels: { [key in TestResult]: string } = {
  invalid: "Ungültig",
  negativ: "Negative",
  positiv: "Positive",
};

const ResultFilter: React.FC<Props> = ({ onChange, onClear, value }) => {
  const selected =
    React.useMemo(() => items?.find((result) => value === result), [value]) ||
    null;
  return (
    <Autocomplete<TestResult>
      id="user-filter-autocomplete"
      options={items}
      value={selected}
      getOptionLabel={(option) => labels[option]}
      onChange={(_, selection) => {
        if (selection) {
          onChange(selection);
        } else {
          onClear();
        }
      }}
      getOptionSelected={(option, value) =>
        value && value ? option === value : false
      }
      style={{ width: 200 }}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Ergebnis"
          variant="outlined"
          size={"small"}
        />
      )}
    />
  );
};

export default ResultFilter;
